import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { isMobileApp } from '../../helpers/app';
import { DEFAULT_DESCRIPTION } from '../App/constants';
import {
  META_LOGO_URL,
  META_NAME,
  META_SOCIALS,
  META_WEBSITE_URL,
} from './constants';
import HomePageView from './View';

interface HomePageProps {}

export const HomePage: React.FC<HomePageProps> = () => {
  return (
    <Fragment>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Organization',
            url: META_WEBSITE_URL,
            logo: META_LOGO_URL,
            name: META_NAME,
            description: DEFAULT_DESCRIPTION,
            sameAs: META_SOCIALS,
            founders: [
              {
                '@type': 'Person',
                name: 'Simon Robain',
              },
              {
                '@type': 'Person',
                name: 'Hugo Bazin',
              },
            ],
            address: {
              '@type': 'PostalAddress',
              streetAddress: '25 Rue Sainte-Apolline',
              addressLocality: 'Paris',
              addressRegion: 'Paris',
              postalCode: '75002',
              addressCountry: 'FR',
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            name: META_NAME,
            url: META_WEBSITE_URL,
          })}
        </script>

        <link
          href={`${window.location.protocol}//${window.location.host}`}
          rel="canonical"
        />
        <meta
          content={`${window.location.protocol}//${window.location.host}`}
          property="og:url"
        />
      </Helmet>
      <HomePageView isReduce={isMobileApp(navigator.userAgent)} />
    </Fragment>
  );
};

export default HomePage;
